"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isDebugEnabled() {
    var isEnabled = false;
    try {
        isEnabled = localStorage.getItem('debug-info') != null;
    }
    catch (err) {
        console.error(err);
    }
    return isEnabled;
}
exports.default = isDebugEnabled;
//# sourceMappingURL=isDebugEnabled.js.map